import { Reveal } from "../lib/anim";

const CHAPTERS = [
  {
    n: "01",
    title: "Traffic is not wasted time.",
    body: "Every kilometre you already drive becomes verifiable, geolocated map data the world needs. You move, the network grows, your balance ticks.",
  },
  {
    n: "02",
    title: "Idle data is idle money.",
    body: "Your unused daily 4G/5G packs sit there expiring. GeoNetix safely puts that leftover bandwidth to work, farming rewards every single second.",
  },
  {
    n: "03",
    title: "Rewards you can actually spend.",
    body: "No volatile tokens. No wallets. No 30% tax paperwork. Just clean Indian Rupees landing in your bank account — real petrol money.",
  },
];

export const Manifesto = () => {
  return (
    <section
      data-testid="manifesto-section"
      className="relative py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12"
    >
      <Reveal>
        <p className="font-mono-gx text-xs uppercase tracking-[0.25em] text-[#00B4D8] mb-4">
          / The GeoNetix Manifesto
        </p>
        <h2 className="font-display font-black text-3xl md:text-5xl tracking-tight max-w-3xl leading-[1.1]">
          A network that turns everyday{" "}
          <span className="gx-text-gradient">motion into money.</span>
        </h2>
      </Reveal>

      <div className="mt-16 divide-y divide-white/10 border-t border-white/10">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.08}>
            <div className="group grid md:grid-cols-[160px_1fr] gap-4 md:gap-12 py-10 md:py-12 transition-colors duration-300 hover:bg-white/[0.02]">
              <div className="font-mono-gx text-5xl md:text-7xl font-bold text-white/15 group-hover:text-[#00B4D8]/60 transition-colors duration-300">
                {c.n}
              </div>
              <div>
                <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight mb-3">
                  {c.title}
                </h3>
                <p className="text-slate-400 text-base md:text-lg max-w-2xl leading-relaxed">
                  {c.body}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
